<section>
	<lbca-textarea
		[label]="'Link da audiência  Exemplo: https://legalbox.com.br'"
		(changeValue)="onchage($event)"
		[value]="lane.audienceLink"
		[disabled]="isDisabled"
	></lbca-textarea>

	<div class="flex justify-end mt-[10px]">
		<button [disabled]="isDisabled" (click)="saveLink()" class="btn-primary btn-type-1">
			@if (statusLoader) {
				<span><img class="forgot-loading" src="./assets/icons/loading-points.svg" /></span>
			}
			@if (!statusLoader) {
				<span>Salvar</span>
			}
		</button>
	</div>
</section>
